import { render, staticRenderFns } from "./SummaryBox.vue?vue&type=template&id=6c1d3da7&scoped=true&"
import script from "./SummaryBox.vue?vue&type=script&lang=ts&"
export * from "./SummaryBox.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryBox.vue?vue&type=style&index=0&id=6c1d3da7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d3da7",
  null
  
)

export default component.exports